import { render, staticRenderFns } from "./AttributesCheckbox.vue?vue&type=template&id=49fd7f6c&scoped=true&"
import script from "./AttributesCheckbox.vue?vue&type=script&lang=js&"
export * from "./AttributesCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AttributesCheckbox.vue?vue&type=style&index=0&id=49fd7f6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd7f6c",
  null
  
)

export default component.exports